import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getQuotesByTickers } from '../api/quotes.ts'
import type { QuoteSnapshot } from '../types.ts'

type UseQuotesData = {
  results: QuoteSnapshot[]
  missingSymbols: string[]
  bySymbol: Record<string, QuoteSnapshot>
}

export function useQuotes(symbols: string[]) {
  const normalizedSymbols = useMemo(
    () => [...new Set(symbols.map((symbol) => symbol.trim().toUpperCase()).filter(Boolean))],
    [symbols],
  )

  return useQuery({
    queryKey: ['quotes', normalizedSymbols.join(',')],
    enabled: normalizedSymbols.length > 0,
    queryFn: () => getQuotesByTickers(normalizedSymbols),
    select: (data): UseQuotesData => {
      const bySymbol: Record<string, QuoteSnapshot> = {}
      for (const quote of data.results) {
        bySymbol[quote.symbol] = quote
      }

      return {
        ...data,
        bySymbol,
      }
    },
  })
}

